__turbopack_context__.v({
  "body": "_7dbT_W_body",
  "center": "_7dbT_W_center",
  "row": "_7dbT_W_row",
  "separator": "_7dbT_W_separator",
});
